export default __webpack_public_path__ + "static/media/img6.c4baf77d.png";